var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vs-popup",
        {
          staticClass: "popup90",
          attrs: {
            fullscreen: false,
            title: "Editar parcelas em lote",
            active: _vm.localShow,
          },
          on: {
            "update:active": function ($event) {
              _vm.localShow = $event
            },
          },
        },
        [
          _c("div", { staticClass: "vx-row" }, [
            _c(
              "div",
              { staticClass: "vx-col w-full mt-0 mb-2 flex items-center" },
              [
                _c(
                  "vs-checkbox",
                  {
                    staticClass: "select-all-chexkbox",
                    attrs: {
                      disabled: !_vm.transactions.length,
                      "icon-pack": "feather",
                      icon: _vm.selectAllIcon,
                    },
                    model: {
                      value: _vm.selectAllCheckBox,
                      callback: function ($$v) {
                        _vm.selectAllCheckBox = $$v
                      },
                      expression: "selectAllCheckBox",
                    },
                  },
                  [_vm._v("Selecionar Tudo")]
                ),
                _c(
                  "vs-button",
                  {
                    staticClass: "ml-auto",
                    attrs: { color: "secondary" },
                    on: { click: _vm.cancel },
                  },
                  [_vm._v("Cancelar")]
                ),
                _c(
                  "vs-button",
                  {
                    staticClass: "ml-4",
                    attrs: {
                      disabled:
                        !_vm.selectedTransactions.length ||
                        !_vm.validateBatchPayment,
                    },
                    on: { click: _vm.batchEdit },
                  },
                  [_vm._v("Editar Selecionadas")]
                ),
                _c(
                  "vs-button",
                  {
                    staticClass: "ml-4",
                    attrs: {
                      color: "danger",
                      disabled: !_vm.selectedTransactions.length,
                    },
                    on: { click: _vm.confirmBatchDelete },
                  },
                  [_vm._v("Deletar Selecionadas")]
                ),
              ],
              1
            ),
          ]),
          _vm.transactions.length
            ? _c(
                "vs-table",
                {
                  staticStyle: { overflow: "-webkit-paged-y" },
                  attrs: { data: _vm.transactions, hoverFlat: "", stripe: "" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ data }) {
                          return [
                            _vm._l(data, function (transaction, i) {
                              return _c(
                                "vs-tr",
                                {
                                  key: i,
                                  staticStyle: { opacity: "1 !important" },
                                },
                                [
                                  _c(
                                    "vs-td",
                                    [
                                      _c("vs-checkbox", {
                                        staticClass:
                                          "vs-checkbox-small ml-0 mr-1",
                                        attrs: { "vs-value": transaction },
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeCheckBox(
                                              transaction
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.selectedTransactions,
                                          callback: function ($$v) {
                                            _vm.selectedTransactions = $$v
                                          },
                                          expression: "selectedTransactions",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vs-td",
                                    [
                                      _c("vs-input", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate.initial",
                                            value: {
                                              required:
                                                _vm.selectedTransactions.some(
                                                  (e) => e.id === transaction.id
                                                ),
                                            },
                                            expression:
                                              "{ required: selectedTransactions.some(e => e.id === transaction.id) }",
                                            modifiers: { initial: true },
                                          },
                                        ],
                                        staticClass: "w-48",
                                        attrs: {
                                          type: "date",
                                          "data-vv-as": "Vencimento",
                                          "data-vv-scope": "batchPayment",
                                          name: "expiration_date" + i,
                                        },
                                        model: {
                                          value: transaction.expiration_date,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              transaction,
                                              "expiration_date",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "transaction.expiration_date",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "batchPayment.expiration_date" +
                                                  i
                                              ),
                                              expression:
                                                "errors.has('batchPayment.expiration_date'+i)",
                                            },
                                          ],
                                          staticClass: "text-danger text-sm",
                                        },
                                        [_vm._v("Campo obrigatório")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("vs-td", [
                                    _c(
                                      "span",
                                      {
                                        style:
                                          transaction.type === "DEBIT" &&
                                          "color: red",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            transaction.student
                                              ? transaction.student.name
                                              : ""
                                          ) +
                                            " " +
                                            _vm._s(transaction.observation) +
                                            " " +
                                            _vm._s(
                                              transaction.servicePackages &&
                                                transaction.servicePackages
                                                  .map(
                                                    (a) =>
                                                      ` ${a["name"]} ${
                                                        a["category_cnh"] || ""
                                                      }`
                                                  )
                                                  .join(", ")
                                            )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "vs-td",
                                    [
                                      _c("v-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate.initial",
                                            value: {
                                              required:
                                                _vm.selectedTransactions.some(
                                                  (e) => e.id === transaction.id
                                                ) &&
                                                !transaction.type_payment_id,
                                            },
                                            expression:
                                              "{ required: selectedTransactions.some(e => e.id === transaction.id) && !transaction.type_payment_id }",
                                            modifiers: { initial: true },
                                          },
                                        ],
                                        staticClass:
                                          "vue_select_drop_size_100 w-48",
                                        attrs: {
                                          clearable: false,
                                          reduce: (option) => option.value,
                                          options: _vm.typePayments,
                                          placeholder: "Selecione",
                                          dir: _vm.$vs.rtl ? "rtl" : "ltr",
                                          "data-vv-as": "Tipo de Pagamento",
                                          "data-vv-scope": "batchPayment",
                                          name: "type_payment_id" + i,
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.filterAccountsParcels(i)
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "no-options",
                                              fn: function ({}) {
                                                return [
                                                  _vm._v(
                                                    "\n                Nenhum resultado encontrado.\n              "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: transaction.type_payment_id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              transaction,
                                              "type_payment_id",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "transaction.type_payment_id",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "batchPayment.type_payment_id" +
                                                  i
                                              ),
                                              expression:
                                                "errors.has('batchPayment.type_payment_id'+i)",
                                            },
                                          ],
                                          staticClass: "text-danger text-sm",
                                        },
                                        [_vm._v("Campo obrigatório")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vs-td",
                                    [
                                      _c("v-select", {
                                        directives: [
                                          {
                                            name: "validate",
                                            rawName: "v-validate.initial",
                                            value: {
                                              required:
                                                _vm.selectedTransactions.some(
                                                  (e) => e.id === transaction.id
                                                ) && !transaction.account_id,
                                            },
                                            expression:
                                              "{ required: selectedTransactions.some(e => e.id === transaction.id) && !transaction.account_id }",
                                            modifiers: { initial: true },
                                          },
                                        ],
                                        staticClass:
                                          "vue_select_drop_size_100 w-48",
                                        attrs: {
                                          clearable: false,
                                          disabled:
                                            !transaction.type_payment_id,
                                          reduce: (option) => option.value,
                                          options:
                                            transaction.accountsFilteredOptions,
                                          placeholder: "Selecione",
                                          dir: _vm.$vs.rtl ? "rtl" : "ltr",
                                          "data-vv-as": "Conta",
                                          "data-vv-scope": "batchPayment",
                                          name: "account_id" + i,
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "no-options",
                                              fn: function ({}) {
                                                return [
                                                  _vm._v(
                                                    "\n                Nenhum resultado encontrado.\n              "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: transaction.account_id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              transaction,
                                              "account_id",
                                              $$v
                                            )
                                          },
                                          expression: "transaction.account_id",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.errors.has(
                                                "batchPayment.account_id" + i
                                              ),
                                              expression:
                                                "errors.has('batchPayment.account_id'+i)",
                                            },
                                          ],
                                          staticClass: "text-danger text-sm",
                                        },
                                        [_vm._v("Campo obrigatório")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "vs-td",
                                    [
                                      _c("currency-input", {
                                        staticClass:
                                          "w-32 vs-inputx vs-input--input normal hasValue",
                                        attrs: {
                                          currency: { prefix: "R$ " },
                                          valueAsInteger: false,
                                          distractionFree: false,
                                          precision: 2,
                                          autoDecimalMode: true,
                                          valueRange: { min: 0 },
                                          allowNegative: false,
                                        },
                                        model: {
                                          value: transaction.value_parcel,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              transaction,
                                              "value_parcel",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "transaction.value_parcel",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            _c(
                              "vs-tr",
                              { staticStyle: { opacity: "1 !important" } },
                              [
                                _c(
                                  "vs-td",
                                  { attrs: { colspan: "8" } },
                                  [
                                    _c("vs-divider"),
                                    _c(
                                      "div",
                                      { staticClass: "vx-col w-full" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "mt-2 flex flex-wrap items-center",
                                          },
                                          [
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "ml-auto mb-2",
                                                attrs: { color: "secondary" },
                                                on: { click: _vm.cancel },
                                              },
                                              [_vm._v("Cancelar")]
                                            ),
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "ml-4 mb-2",
                                                attrs: {
                                                  disabled:
                                                    !_vm.selectedTransactions
                                                      .length ||
                                                    !_vm.validateBatchPayment,
                                                },
                                                on: { click: _vm.batchEdit },
                                              },
                                              [_vm._v("Editar Selecionadas")]
                                            ),
                                            _c(
                                              "vs-button",
                                              {
                                                staticClass: "ml-4 mb-2",
                                                attrs: {
                                                  color: "danger",
                                                  disabled:
                                                    !_vm.selectedTransactions
                                                      .length,
                                                },
                                                on: {
                                                  click: _vm.confirmBatchDelete,
                                                },
                                              },
                                              [_vm._v("Deletar Selecionadas")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2071060598
                  ),
                },
                [
                  _c(
                    "template",
                    { slot: "thead" },
                    [
                      _c("vs-th", [_vm._v("#")]),
                      _c("vs-th", [_vm._v("Vencimento")]),
                      _c("vs-th", [_vm._v("Descrição")]),
                      _c("vs-th", [_vm._v("Forma Pagamento")]),
                      _c("vs-th", [_vm._v("Conta")]),
                      _c("vs-th", [_vm._v("Valor Parcela")]),
                    ],
                    1
                  ),
                ],
                2
              )
            : _vm._e(),
          !_vm.transactions.length
            ? _c(
                "vs-alert",
                {
                  staticClass: "mt-4 mb-4",
                  staticStyle: { height: "auto" },
                  attrs: {
                    active: true,
                    color: "warning",
                    "icon-pack": "feather",
                    icon: "icon-info",
                  },
                },
                [
                  _c("span", [
                    _vm._v(
                      "Nenhuma parcela em aberto para o período selecionado!"
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }